import {
  CountryCode,
  E164Number,
  ParseError,
  parsePhoneNumberWithError,
} from 'libphonenumber-js';

export function parsePhoneNumber(
  phone: string,
  country: CountryCode = 'US'
): E164Number | undefined {
  try {
    const phoneNumber = parsePhoneNumberWithError(phone, country);

    return phoneNumber.isValid() ? phoneNumber.number : undefined;
  } catch (error) {
    if (error instanceof ParseError) {
      return undefined;
    }
    throw error;
  }
}

// Phone numbers are PII. Keep only the last four characters visible,
// following the same convention as obfuscateSsn.
export const obfuscatePhone = (phone: string | null | undefined) => {
  if (!phone) {
    return null;
  }

  const visiblePart = phone.slice(-4);
  return visiblePart.padStart(phone.length, 'X');
};
